import React from "react";
import birds from "../assets/birds.gif"
import closed from "../assets/closed.gif"
const ShopClosed = () => {
    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 text-center px-4">
            {/* Bird GIF */}
            <img
                src={birds}
                alt="Bird"
                className="w-auto h-32 mb-4 animate-bounce"
            />

            {/* Closed GIF */}
            <img
                src={closed}
                alt="Shop Closed"
                className="w-auto h-48 mb-6"
            />

            {/* Message */}
            <p className="text-xl md:text-2xl text-gray-700 font-semibold">
                Sorry, the shop is currently <span className="text-red-500">closed</span>.
            </p>
            <p className="text-gray-500 mt-2 text-sm md:text-base">
                Orders can’t be placed at this moment. Please check back later.
            </p>
        </div>
    );
};

export default ShopClosed;
